// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-inset[data-v-0a904c24]{margin:0 auto;width:calc(100% - 32px)}@media(min-width:720px){.app-inset[data-v-0a904c24]{width:calc(100% - 64px)}}@media(min-width:1025px){.app-inset[data-v-0a904c24]{max-width:1280px;width:calc(100% - 160px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
